import { getAuthData, removeAuthData } from '@/shared/utils/auth';
import { FunctionComponent, ReactElement, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface GuestGuardProps {
	element: ReactNode;
	forceLogout?: boolean;
}

const GuestGuard: FunctionComponent<GuestGuardProps> = ({ element, forceLogout }): ReactElement => {
	if (forceLogout) {
		removeAuthData();
	}

	const { accessToken } = getAuthData() || {};
	if (accessToken) {
		return <Navigate to="/" replace={true} />;
	}

	return <>{element}</>;
};

export default GuestGuard;
